// extracted by mini-css-extract-plugin
export default {"overviewContainer":"styles_overviewContainer__DCBEs","title":"styles_title__RJa4G","overviewTable":"styles_overviewTable__MrEJ+"};